import type { Item } from 'models/IItem';
import { useContext } from 'react';
import { type RemunerationMode as RemunerationModeEnum } from 'state/addonForm';

import { AddonMainFormContext } from '../AddonMainForm.context';
import { ListField } from './ListField';

type OwnProps = {
  value?: RemunerationModeEnum;
  visible: boolean;
  wrapper?: string;
  onChange: (newRemunerationMode: RemunerationModeEnum) => void;
};

const noteWarrantRemunerationModes: readonly Item<RemunerationModeEnum>[] = [
  { value: 'Upfront', label: 'Upfront' },
  { value: 'Reoffer', label: 'Reoffer' },
];
export function RemunerationMode({ value, visible, onChange }: OwnProps) {
  const { isLoading, isReadOnly } = useContext(AddonMainFormContext);

  if (!visible) {
    return null;
  }

  return (
    <ListField
      id="remunerationMode"
      disabled={isReadOnly}
      isLoading={isLoading}
      translationKey="remunerationMode"
      availableItems={noteWarrantRemunerationModes}
      value={value!}
      onValueChange={onChange}
    />
  );
}
